class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.hasHistory = this.hasAttribute('data-has-history');
    if (this.querySelector('[id^="ModalClose-"]')) {
      this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    }
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    this.addEventListener('click', (event) => {
      if (event.target === this) this.hide();
    });
    if (this.hasHistory) {
      window.addEventListener('popstate', () => {
        if (this.hasAttribute('open')) {
          this.hide();
        }
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    this.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
    if (this.hasHistory) {
      history.pushState({ openedModalDialogId: this.id }, '');
    }
    window.dispatchEvent(
      new CustomEvent('modalOpened', {
        detail: {
          modalId: this.id,
        },
      }),
    );
  }

  hide() {
    document.body.style.overflow = 'visible';
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    if (this.hasHistory && history.state.openedModalDialogId === this.id) {
      history.back();
    }
    window.dispatchEvent(
      new CustomEvent('modalClosed', {
        detail: {
          modalId: this.id,
        },
      }),
    );
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);
